<div
  class="left-side-panel"
  [class.overlapping]="isSmallScreen"
  [class.open]="isOpened"
>
  <div class="side-panel-container">
    <div *ngIf="isSmallScreen" class="button-container">
      <dx-button
        class="open-button"
        [icon]="isOpened ? 'hidepanel' : 'showpanel'"
        (onClick)="toggleOpen()"
      >
      </dx-button>
    </div>

    <div class="side-panel-content-wrapper">
      <dx-scroll-view style="max-height: 100%">
        <ng-content></ng-content>
      </dx-scroll-view>
    </div>
  </div>
</div>
